const TeamFilterOptionValues = {
  HOME_TEAM: 'homeTeam',
  AWAY_TEAM: 'awayTeam',
} as const;

export default TeamFilterOptionValues;
